<div>
  <router-outlet></router-outlet>
</div>

<toast-message></toast-message>
